<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <abook-button type="text" (clickFn)="onCancel()">{{ data.cancelText || 'Annuller' }}</abook-button>
  <abook-button type="filled" cdkFocusInitial (clickFn)="onConfirm()">
    {{ data.confirmText || 'OK' }}
  </abook-button>
</mat-dialog-actions>
